import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js';

import './style.scss';

const moduleSelector = '.eiovisual-list1';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo list1');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {

        // Tasks on images
        if(!isMobile.check()) {
            setTimeout(this.task1(),0); // avvia la funzionalità
        }
    }

    // _________________________________________________________________________

    /**
     * Sostituisce gli elementi .fit-text con elementi fit-text
     * @returns {undefined}
     */
    task1() {
        // definisce il target
        // let $target = this.$module.querySelector('.target');
    }

    // _________________________________________________________________________

}

// export
export default new Module();